// NOTE: this is a temporary solution to fix the issue connected with authorization
// inside webview due to different auth approach; without this code the webview will
// not be able to access the site designer
import Cookies from 'js-cookie'
import { useEffect } from 'react'

import { useAuth } from '@fourthwall/auth'
import { isWebViewUserAgent } from '@fourthwall/webview-bridge/utils'

export const useMobileCookies = (deps: unknown[]) => {
  const { keycloak } = useAuth()

  const accessTokenAttributes: (typeof Cookies)['attributes'] = {
    sameSite: 'lax',
    secure: true,
  }
  const refreshTokenAttributes: (typeof Cookies)['attributes'] = {
    sameSite: 'strict',
    secure: true,
  }

  useEffect(() => {
    if (!isWebViewUserAgent(navigator.userAgent)) return

    // @ts-ignore
    Cookies.set('creator_access_token', keycloak?.token, {
      ...accessTokenAttributes,
    })
    Cookies.set('creator_refresh_token', keycloak?.refreshToken!, {
      ...refreshTokenAttributes,
    })
  }, deps)
}
